// src/pages/attendance/utils/attendanceHelpers.js
import { CheckCircle, AlertCircle, XCircle, Clock } from "lucide-react";

export const formatTimeForDisplay = (timeString, language) => {
  if (!timeString || timeString === "-" || timeString === "undefined") return "--:--";
  try {
    const locale = language === "ar" ? "ar-EG" : "en-US";
    const d = new Date(timeString);
    if (!isNaN(d.getTime())) return d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hour12: true });
    return timeString;
  } catch { return "--:--"; }
};

export const calculateWorkingHours = (checkIn, checkOut) => {
  if (!checkIn || !checkOut || checkIn === "-" || checkOut === "-") return "--";
  try {
    const diff = new Date(checkOut) - new Date(checkIn);
    const hours = diff / (1000 * 60 * 60);
    return hours > 0 ? hours.toFixed(1) : "--";
  } catch { return "--"; }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case "present": return CheckCircle;
    case "late":    return AlertCircle;
    case "absent":  return XCircle;
    default:        return Clock;
  }
};

export const getStatusColor = (status, colors) => {
  switch (status) {
    case "present": return colors.success;
    case "late":    return colors.warning;
    case "absent":  return colors.danger;
    default:        return colors.textMuted;
  }
};

export const getStatusText = (status, t) => t.status[status] || status;

export const formatTime = (date, language) =>
  date.toLocaleTimeString(language === "ar" ? "ar-EG" : "en-US", {
    hour12: true, hour: "2-digit", minute: "2-digit", second: "2-digit",
  });

export const formatDate = (date, language) =>
  date.toLocaleDateString(language === "ar" ? "ar-EG" : "en-US", {
    weekday: "long", year: "numeric", month: "long", day: "numeric",
  });